import React, { useState } from 'react';
import './MessageBubble.css';
import { formatLocal } from '../../utils/dates';
import EmbedRenderer from '../chat/embeds/EmbedRenderer';
import MarkdownRenderer from './MarkdownRenderer';

export default function MessageBubble({ message, onRetry }) {
  const isUser = message.role === 'user';
  const isThinking = message.role === 'assistant' && message.text === 'Thinking…';
  const isLoading = message.isLoading || false;
  const isStreaming = message.isStreaming || false;
  const [editMode, setEditMode] = useState(false);
  const [draft, setDraft] = useState(message.text || '');

  if (isUser) {
    return (
      <div className="bubble user">
        <div className="bubble-inner">
          <div className="meta">
            <time dateTime={message.createdAt || ''}>{formatLocal(message.createdAt)}</time>
          </div>
          {message.editable && !editMode && (
            <div className="bubble-actions">
              <button className="btn" onClick={() => setEditMode(true)}>Edit & resend</button>
            </div>
          )}
          {editMode ? (
            <div className="edit-area">
              <textarea value={draft} onChange={(e) => setDraft(e.target.value)} />
              <div className="row">
                <button className="btn" onClick={() => setEditMode(false)}>Cancel</button>
                <button className="btn primary">Resend</button>
              </div>
            </div>
          ) : (
            <div className="text">
              <MarkdownRenderer content={message.text} />
            </div>
          )}
          {!editMode && message.embeds && Array.isArray(message.embeds) && <EmbedRenderer embeds={message.embeds} />}
        </div>
      </div>
    );
  }

  return (
    <div className="bubble assistant">
      {!isThinking && !isLoading && (
        <div className="ai-label-row">
          <span className="ai-label-dot" aria-hidden="true"></span>
          <span className="ai-label-text">WEALTH-Y</span>
        </div>
      )}
      <div className="assistant-message">
        <div className="text">
          {message.error ? (
            <div className="assistant-error" role="alert">
              <strong>{message.error.title || 'Response interrupted'}</strong>
              <p>{message.error.message || 'I couldn’t get a response right now. Please try again.'}</p>
              {onRetry && (
                <button type="button" className="assistant-error__retry" onClick={onRetry}>
                  Try again
                </button>
              )}
            </div>
          ) : isThinking || isLoading ? (
            <div className="thinking-indicator" role="status" aria-live="polite" aria-label="Assistant is thinking">
              <span className="visually-hidden">Thinking</span>
              <span className="thinking-dot" />
              <span className="thinking-dot" />
              <span className="thinking-dot" />
            </div>
          ) : (
            <>
              <MarkdownRenderer content={message.text} />
              {isStreaming && message.text && (
                <span className="streaming-cursor" aria-label="Streaming">▋</span>
              )}
            </>
          )}
        </div>
      </div>
      {message.embeds && Array.isArray(message.embeds) && <EmbedRenderer embeds={message.embeds} />}
    </div>
  );
}
